import React, { useState } from 'react';
import {
	Analysis,
	CardWrapper,
	ContentWrapper,
	ExploreButton,
	Heading,
	IconWrapper,
	RiskWrapper,
	SubWrapper,
	Wrapper,
} from './Cards.styles';
import { ApIcon, ApLoaderDefault } from '@alixpartners/ui-components';
import { cardColorDefault, iconColor } from './utils';
import { InsightsType } from 'CategoryManagement/utils';
import { useSignificantYoyGrowthContext } from 'contexts/CategoryInsightsKpi/SignificantYoyGrowthProvider';
import SignificantYoyGrowthExplore from 'CategoryManagement/Explore/DetailedAnalysis/SignificantYoyGrowthExplore';
import ExploreModal from 'CategoryManagement/Explore/ExploreModal';

const SignificantYoyGrowth = ({ name }) => {
	const { isLoading, analysis, gridData } = useSignificantYoyGrowthContext();
	const [isExplore, setIsExplore] = useState(false);

	return (
		<>
			<Wrapper>
				<SubWrapper>
					<RiskWrapper tileColor={cardColorDefault} />
					<CardWrapper>
						<IconWrapper iconColor={iconColor}>
							<div>
								<ApIcon
									material={true}
									iconName={InsightsType[1].iconName}
									iconSize={20}
								/>
							</div>
							<div>
								{!isLoading &&
									gridData.rowData.length > 0 && (
										<ExploreButton
											title="Explore"
											className="explore"
											onClick={() => setIsExplore(true)}
										>
											<ApIcon
												title="Explore"
												material={true}
												iconName="find_in_page"
											/>
										</ExploreButton>
									)}
							</div>
						</IconWrapper>
						{isLoading ? (
							<ApLoaderDefault />
						) : (
							<ContentWrapper>
								<Heading>{name}</Heading>
								<Analysis>{analysis}</Analysis>
							</ContentWrapper>
						)}
					</CardWrapper>
				</SubWrapper>
			</Wrapper>
			{isExplore && (
				<ExploreModal title={name} onClose={setIsExplore}>
					<SignificantYoyGrowthExplore />
				</ExploreModal>
			)}
		</>
	);
};

export default SignificantYoyGrowth;
